import { withSvgIcon } from './withSvgIcon';

export const BulbIcon = withSvgIcon(
  <>
    <path
      d="M12 2C8.5794 2 6 4.8 6 8C6 10.5 7.5 12 8.5 13C9.58262 14.0826 9.5 14.9333 9.5 16V18H14.5V16C14.5 14.9333 14.5 14 15.5 13C16.5 12 18 10.6667 18 8C18 4.8 15.4206 2 12 2Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M8.5 21H15.5"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
